var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoConversationVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 252,
    viewBox: "0 0 338 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4768_68635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169 251.887C241.387 251.887 300.069 248.461 300.069 244.235C300.069 240.009 241.387 236.583 169 236.583C96.6118 236.583 37.9299 240.009 37.9299 244.235C37.9299 248.461 96.6118 251.887 169 251.887Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338 221.365H0V221.534H338V221.365Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.132 232.239H281.743V232.408H304.132V232.239Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.904 234.077H218.03V234.246H223.904V234.077Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.067 225.965H268.095V226.134H281.067V225.965Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.66 227.101H35.4636V227.27H64.66V227.101Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.962 227.101H70.6829V227.27H74.962V227.101Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.202 229.953H88.8742V230.122H152.202V229.953Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.836 38.6799V172.92L44.5455 172.92L44.5455 38.6799L295.836 38.6799Z",
    fill: "#FAFAFA",
    stroke: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.868 79.0175C225.092 75.3333 230.892 72.3522 235.867 72.3522C237.064 72.3522 238.105 72.5279 238.97 72.8389C242.343 70.1349 247.183 68.2759 251.51 68.2759C256.742 68.2759 259.5 71.0002 258.432 74.637C263.211 74.8736 265.307 77.9021 263.117 81.6134C260.832 85.4733 254.761 88.6032 249.556 88.6032H219.576C215.885 88.6032 214.208 86.3859 215.831 83.6481C217.081 81.5322 219.934 79.7273 222.875 79.0175H222.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.385 61.5137C163.744 59.2627 167.286 57.4442 170.321 57.4442C171.051 57.4442 171.687 57.5524 172.214 57.7417C174.276 56.0922 177.23 54.9565 179.866 54.9565C183.057 54.9565 184.74 56.6195 184.091 58.8368C187.012 58.9787 188.289 60.831 186.951 63.0956C185.558 65.4548 181.854 67.3611 178.677 67.3611H160.377C158.126 67.3611 157.099 66.0091 158.093 64.3327C158.856 63.0415 160.6 61.9396 162.392 61.507L162.385 61.5137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5117 74.8331C75.8705 72.582 79.4127 70.7636 82.4479 70.7636C83.178 70.7636 83.8135 70.8717 84.3407 71.061C86.4025 69.4116 89.3567 68.2759 91.9931 68.2759C95.1838 68.2759 96.867 69.9388 96.2181 72.1561C99.1384 72.2981 100.416 74.1503 99.0775 76.4149C97.685 78.7742 93.9805 80.6805 90.8033 80.6805H72.504C70.2529 80.6805 69.2254 79.3285 70.2191 77.652C70.983 76.3608 72.7271 75.259 74.5185 74.8263L74.5117 74.8331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.023 64.8779H91.1615V161.025H112.023V64.8779Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.504 161.023H109.684V84.1758L128.504 102.914V161.023Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7267 96.6343H63.8653V161.023H84.7267V96.6343Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.147 88.6118H134.514V161.032H145.147V88.6118Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.303 107.107H149.67V161.025H160.303V107.107Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.348 124.82H157.714V161.027H168.348V124.82Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.477 124.82H201.843V161.027H212.477V124.82Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.302 136.249H191.669V161.031H202.302V136.249Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9445 124.82H50.311V161.027H60.9445V124.82Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.677 118.794H56.4148V161.024H152.677V118.794Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.477 144.097H116.214V161.024H212.477V144.097Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.666 173.412H231.979V77.2646H199.666V173.412Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.127 173.412H203.289V96.5645L174.127 115.303V173.412Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.957 173.412H274.27V109.023H241.957V173.412Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.351 173.412H164.825V100.992H148.351V173.412Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.86 173.412H141.334V125.092H124.86V173.412Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.415 173.412H128.889V137.206H112.415V173.412Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0436 173.412H60.5178L60.5178 137.206H44.0436V173.412Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8016 173.412H76.2757V148.63H59.8016V173.412Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.799 173.412H295.273V137.206H278.799V173.412Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.684 173.412L285.809 173.412V131.182L136.684 131.182V173.412Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.044 173.412L193.17 173.412V156.485L44.044 156.485V173.412Z",
    fill: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.8043 228.802C62.4663 228.802 62.1216 228.694 61.8376 228.464C61.1616 227.93 61.0535 226.95 61.5875 226.274C62.4731 225.158 60.3234 222.576 58.052 219.845C53.2119 214.018 45.8908 205.216 55.8888 195.124C62.1959 188.749 62.054 186.112 61.7024 185.274C61.0805 183.801 58.2008 183.469 57.2003 183.469C57.1868 183.469 57.18 183.469 57.1665 183.469C56.308 183.469 55.6117 182.78 55.6049 181.921C55.5982 181.063 56.2877 180.36 57.1462 180.346C57.7343 180.346 63.0274 180.387 64.5822 184.051C65.9274 187.221 63.8116 191.561 58.1129 197.314C50.109 205.399 55.6117 212.01 60.4586 217.851C63.5682 221.589 66.502 225.118 64.0414 228.214C63.7304 228.599 63.2775 228.802 62.8178 228.802H62.8043Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2386 214.748H73.5114L66.143 246.439H47.607L40.2386 214.748Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8942 216.159H73.8632C74.6406 216.159 75.276 215.523 75.276 214.746C75.276 213.968 74.6406 213.333 73.8632 213.333H39.8942C39.1168 213.333 38.4813 213.968 38.4813 214.746C38.4813 215.523 39.1168 216.159 39.8942 216.159Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5703 181.355L37.1295 191.738C37.1295 191.738 25.7389 184.045 34.0131 180.584C30.0788 173.871 29.5786 160.784 42.24 156.985C54.9015 153.186 54.016 171.681 54.016 171.681C54.016 171.681 69.6316 155.167 68.9015 174.784C71.8691 173.966 84.5036 176.954 68.5703 181.348V181.355Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3282 195.576H80.4546C80.4546 195.576 90.5067 188.478 79.9746 188.829C82.0635 179.777 76.1687 169.861 62.8718 169.475C49.5749 169.09 54.2461 183.854 54.2461 183.854C54.2461 183.854 31.8975 178.527 38.6575 189.532C27.5779 190.066 33.3103 192.905 42.3282 195.569V195.576Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7681 197.625L42.8213 198.706C41.3544 198.761 39.901 198.037 38.8802 196.584C37.7513 194.982 37.4538 192.981 42.2399 192.399C40.7054 187.661 44.0922 179.413 56.4765 178.778C68.854 178.143 62.6484 189.58 62.6484 189.58C62.6484 189.58 81.3803 181.401 74.9854 193.562C77.8719 193.461 88.235 197.064 72.7681 197.618V197.625Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.749 153.18H108V156.471H239.749V153.18Z",
    fill: "#245CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.748 156.479H254V153.188H239.748V156.479Z",
    fill: "#245CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.984 158.12L251.801 158.12V156.471L109.984 156.471V158.12Z",
    fill: "#CBB4EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.678 157.556V246.18H111.355V157.556H109.678Z",
    fill: "#CBB4EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.986 157.556V246.18H239.664V157.556H237.986Z",
    fill: "#CBB4EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.564 157.556V246.18H251.403V157.556H250.564Z",
    fill: "#CBB4EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.256 157.556V246.18H123.094V157.556H122.256Z",
    fill: "#CBB4EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.817 120.18H212.011C213.631 120.18 214.766 121.511 214.519 123.131L210.298 150.88C210.05 152.5 208.523 153.832 206.893 153.832H156.698C155.078 153.832 153.943 152.5 154.191 150.88L158.411 123.131C158.659 121.511 160.186 120.18 161.817 120.18Z",
    fill: "#245CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.04 120.182H211.235C212.855 120.182 213.99 121.513 213.742 123.134L209.522 150.883C209.274 152.503 207.747 153.834 206.116 153.834H155.922C154.302 153.834 153.167 152.503 153.414 150.883L157.635 123.134C157.883 121.513 159.41 120.182 161.04 120.182Z",
    fill: "#245CEA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.04 120.182H211.235C212.855 120.182 213.99 121.513 213.742 123.134L209.522 150.883C209.274 152.503 207.747 153.834 206.116 153.834H155.922C154.302 153.834 153.167 152.503 153.414 150.883L157.635 123.134C157.883 121.513 159.41 120.182 161.04 120.182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M155.923 152.957C155.407 152.957 154.953 152.761 154.654 152.41C154.344 152.049 154.22 151.553 154.293 151.027L158.513 123.278C158.699 122.081 159.855 121.08 161.042 121.08H211.236C211.752 121.08 212.206 121.276 212.505 121.627C212.815 121.988 212.939 122.483 212.866 123.009L208.646 150.759C208.46 151.956 207.304 152.957 206.117 152.957H155.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.269 152.727H207.789C208.398 152.727 208.821 153.222 208.728 153.831H140C140.093 153.222 140.671 152.727 141.28 152.727H141.269Z",
    fill: "#245CEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.251 26.1225C146.251 24.3779 144.84 22.9668 143.096 22.9668C141.351 22.9668 139.94 24.3779 139.94 26.1225C139.94 27.8671 141.351 29.2782 143.096 29.2782C144.84 29.2782 146.251 27.8671 146.251 26.1225Z",
    fill: "white",
    stroke: "#C8D6E6",
    strokeWidth: 0.775358,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.782 26.1225C159.782 24.3779 158.371 22.9668 156.626 22.9668C154.882 22.9668 153.471 24.3779 153.471 26.1225C153.471 27.8671 154.882 29.2782 156.626 29.2782C158.371 29.2782 159.782 27.8671 159.782 26.1225Z",
    fill: "white",
    stroke: "#C8D6E6",
    strokeWidth: 0.775358,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32 26.1225C173.32 24.3779 171.908 22.9668 170.164 22.9668C168.419 22.9668 167.008 24.3779 167.008 26.1225C167.008 27.8671 168.419 29.2782 170.164 29.2782C171.908 29.2782 173.32 27.8671 173.32 26.1225Z",
    fill: "white",
    stroke: "#C8D6E6",
    strokeWidth: 0.775358,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.737 21.7983C185.737 18.4475 183.021 15.7312 179.67 15.7312H119.552V42.7571C119.552 46.1079 122.268 48.8242 125.619 48.8242H179.67C183.021 48.8242 185.737 46.1079 185.737 42.7571V21.7983Z",
    fill: "#F0F1F3",
    stroke: "#C8D6E6",
    strokeWidth: 1.1031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.713 64.8183C158.713 61.163 161.676 58.1997 165.332 58.1997H226.002V85.7772C226.002 89.4325 223.039 92.3957 219.384 92.3957H165.332C161.676 92.3957 158.713 89.4325 158.713 85.7772V64.8183Z",
    fill: "#278EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.426 75.8995C202.426 73.9751 203.982 72.4185 205.907 72.4185C207.831 72.4185 209.388 73.9751 209.388 75.8995C209.388 77.8239 207.831 79.3806 205.907 79.3806C203.982 79.3806 202.426 77.8239 202.426 75.8995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.499 75.8995C187.499 73.9751 189.056 72.4185 190.981 72.4185C192.905 72.4185 194.462 73.9751 194.462 75.8995C194.462 77.8239 192.905 79.3806 190.981 79.3806C189.056 79.3806 187.499 77.8239 187.499 75.8995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.567 75.8995C172.567 73.9751 174.123 72.4185 176.048 72.4185C177.972 72.4185 179.529 73.9751 179.529 75.8995C179.529 77.8239 177.972 79.3806 176.048 79.3806C174.123 79.3806 172.567 77.8239 172.567 75.8995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.576 32.8858C142.576 30.9614 141.02 29.4048 139.095 29.4048C137.171 29.4048 135.614 30.9614 135.614 32.8858C135.614 34.8103 137.171 36.3669 139.095 36.3669C141.02 36.3669 142.576 34.8103 142.576 32.8858Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.503 32.8858C157.503 30.9614 155.946 29.4048 154.022 29.4048C152.097 29.4048 150.541 30.9614 150.541 32.8858C150.541 34.8103 152.097 36.3669 154.022 36.3669C155.946 36.3669 157.503 34.8103 157.503 32.8858Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.435 32.8858C172.435 30.9614 170.879 29.4048 168.954 29.4048C167.03 29.4048 165.473 30.9614 165.473 32.8858C165.473 34.8103 167.03 36.3669 168.954 36.3669C170.879 36.3669 172.435 34.8103 172.435 32.8858Z",
    fill: "#373737"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4768_68635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 338,
    height: 251.884,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoConversationVector);
export default __webpack_public_path__ + "static/media/no-conversation-vector.0fae7e6019e883b136235645a2284c79.svg";
export { ForwardRef as ReactComponent };